import React, { Component } from "react";
import classnames from "classnames";
import Paper from "@material-ui/core/Paper";
import { withTranslation, Trans } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import FormControl from "@material-ui/core/FormControl";
import imgUrl from "../../assets/images/imageUrl.js";
import Loader from "../loaders/loader";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { withStyles, makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import { signInAnonymously } from "../../helpers/auth";
import { auth } from "../../service/firebase";
import { db, storageRef } from "../../service/firebase";
import ApiServices from "../../api/api";
import TextField from "@material-ui/core/TextField";
import Services from "../../api/api";
import swal from "sweetalert";
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";


class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      userDetails: [],
      name: '',
      password: '',
      passwordVisibility: false,
      pin: '',
      pinvisible:false
    };
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangePin = this.handleChangePin.bind(this);
    this.getUserDeatils = this.getUserDeatils.bind(this);
    this.handleExistUser=this.handleExistUser.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  componentDidMount() {
    gaLogEvent("Settings User Login", '', '');
    if (localStorage) { // fix for API
      localStorage.removeItem("firebase:previous_websocket_failure");
  }
    OffileDb.setDatabase()
  }

  handleChangeName(event) {
    // console.log(event)
    this.setState({
      name: event.target.value,
    });
  }
  handleChangePin(event) {
    // console.log(event)
    this.setState({
      pin: event.target.value,
    });
  }
  handleChangePassword(event) {
    // console.log(event)
    this.setState({
      password: event.target.value,
    });
  }

  handleExistUser(event){
    
      console.log("user::",event.target.value)
      // check if pin has been generated for this user and then redirect
      var userParam = {
        "userName": event.target.value
      }
      Services.IdentifyUserType(userParam).then((res) => {
        console.log("IdentifyUserType res::", res)
        if(res.data && res.data.data){
          if(res.data.data.resetPin == false){
            this.setState({
              pinvisible:true
            });
          }else{
            this.setState({
              pinvisible:false
            });
          }
        }
      })
    
  }

  handleSubmit = (event) => {
    const { t } = this.props;
    var self = this;
    console.log(self.state.name,self.state.password)
    if(self.state.name =="" || self.state.password ==""){
      swal({
        title: t("Please enter username and password"),
        icon: "warning",
        button: t("Ok"),
      })
    }else{
    var userParam = {
      "userName": self.state.name
    }
    Services.IdentifyUserType(userParam).then((res) => {
      console.log("IdentifyUserType res::", res)
      if(res.data && res.data.data){
        if(res.data.data.resetPassword==true){
          localStorage.setItem('loggedinuser', self.state.name)
          localStorage.setItem('loggedinpass', self.state.password)
          self.props.history.push("/layout/resetPassword")
        }
        else if(res.data.data.resetPin == true){
          self.props.history.push("/layout/resetPin");
          localStorage.setItem('loggedinuser', self.state.name)
          localStorage.setItem('loggedinpass', self.state.password)
        }else{
          localStorage.setItem('loggedinuser', self.state.name)
          localStorage.setItem('loggedinpass', self.state.password)
          localStorage.setItem('loginattempted', "true")
          self.props.history.push("/layout/LoginPin");
        }
      }
    })
  }
    // self.props.history.push("/layout/LoginPin");
    // localStorage.setItem('loggedinuser', self.state.name)
    // localStorage.setItem('loggedinpass', self.state.password)

    event.preventDefault();
    //const { t } = this.props;
    this.setState({ isLoading: true });

    var param = {
      userName: this.state.name,
      password: this.state.password,
      pin: this.state.pin
    };
    console.log("handleSubmit>>", param, JSON.stringify(param));

    console.log("login param:", param)

    
      // Services.dashboardLogin(param).then((res) => {
      //   console.log("login res::", res);
      //   try {
      //     if (res.data.status == 200) {
            
      //   var userId=res.data.data.userId;
      //       OffileDb.deleteDatabse();
      //       setTimeout(function () {
      //         localStorage.setItem('tempuserobj', localStorage.getItem('obj'))
      //         localStorage.setItem('adminobj', JSON.stringify({
      //           roleId: res.data.data.roleId,
      //           roleType: res.data.data.masterRoleType.roleType,
      //           userId: res.data.data.userId,
      //           userType: res.data.data.userType,
      //           communityId: res.data.data.communityId
      //         }))
      //         localStorage.setItem('obj', JSON.stringify({
      //           roleId: res.data.data.roleId,
      //           roleType: res.data.data.masterRoleType.roleType,
      //           userId: res.data.data.userId,
      //           userType: res.data.data.userType,
      //           communityId: res.data.data.communityId
      //         }))
      //         localStorage.setItem('loggedinuser', res.data.data.userName)
      //         localStorage.setItem('loggedinpass', self.state.password)
              
      //         // check if pin has been generated for this user and then redirect
      //         var userParam = {
      //           "userName": self.state.name
      //         }
      //         Services.IdentifyUserType(userParam).then((res) => {
      //           console.log("IdentifyUserType res::", res)
      //           if(res.data && res.data.data){
      //             if(res.data.data.resetPin == true){
      //               self.props.history.push("/layout/resetPin");
      //             }else{
      //               //self.props.history.push("/layout/loginPin");
      //               self.getUserDeatils(userId)
      //             }
      //           }
      //         })
      //         // self.getUserDeatils(res.data.data.userId)
      //       }, 500);
      //     }
      //   } 
      //   catch (err) {
      //     console.log("Error::", err);
      //     swal({
      //       title: t("Please enter valid username and password"),
      //       icon: "warning",
      //       button: t("Ok"),
      //     })
      //   }
      // });
      
    

  };

  getUserDeatils(userId) {
    var param = {
      "communityId": this.props.communityuid,
      "userId": userId
    }
    ApiServices.getUserProfile(param).then((res) => {
      if (res.status == 200) {
        if(res.data.data.profile && res.data.data.profile.nickName){
          signInAnonymously().then((s) => {
            auth().onAuthStateChanged((user) => {
              if (user) {
                user.updateProfile({
                  displayName: res.data.data.profile.nickName,
                }).then(function (s) {
                    console.log("updateProfile res>>", s);
                  }).catch(function (error) {
                    console.log("updateProfile error>>", error);
                  });
              }
            });
          }).catch((err) => console.log("err>>>", err));
        }
      }
      localStorage.setItem('loggedinname', localStorage.getItem('loggedinuser'));
      this.props.history.push("/layout");
    });
  }

  toggleVisibility() {
    this.setState({
      passwordVisibility: !this.state.passwordVisibility
    })
  }

  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    return (
      <div className="gk-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>

            </div>
          )
        }

        <form
          id="chat-profile"
          onSubmit={this.handleSubmit}

        >

          <Grid container spacing={3} className="gridcontainer">
            
            <Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter username")}</p>
              <TextField
                id="standard-helperText"
                // label={t("Enter username")}
                onChange={this.handleChangeName}
                // onBlur={this.handleExistUser}
              />
            </Grid>
            <Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter password")}</p>
              <div style={{'display':'flex'}}>
              <TextField
                id="standard-helperText"
                className="passpintext"
                // label={t("Enter password")}
                type={this.state.passwordVisibility ? "text" : "password"}
                onChange={this.handleChangePassword}
              />
              <Button className="toggle-pw-visibility2"
                    id="toggle-pw-visibility"
                    onClick={this.toggleVisibility}
                    style={this.state.passwordVisibility ? {} : { textDecoration: "line-through" }}
                  >
                    👁
              </Button>
              </div>
            </Grid>
            {this.state.pinvisible?(<Grid item xs={12} className="profileformholder bgcolorOfCard">
            <p className="chatusername">{t("Enter pin")}</p>
              <TextField
                id="standard-helperText"
                // label={t("Enter pin")}
                onChange={this.handleChangePin}
              />
            </Grid>):("")}
            <Grid item xs={12} className="profileformholder">
              <div className="text-center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="profilesubmitbtn"
                >
                  {t('Login')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const transUserLogin = withTranslation()(UserLogin);
const themeUserLogin = withTheme(transUserLogin);
const routeUserLogin = withRouter(themeUserLogin);
export default connect(mapStateToProps, {})(routeUserLogin);
